/**
 * Canonical import path for the listen-queue context.
 *
 * The provider + hook live in `./AudioContext.tsx` during the Phase 2–7
 * migration (keeps old callers working). New code imports from here so
 * a future rename to `ListenQueueContext.tsx` is a single-file edit.
 */
export {
  AudioProvider,
  useAudio,
  useListenQueue,
  type QueueTrack,
} from './AudioContext';
